import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import CardTemplate from "../Common/CardTemplate";

import MoreTimeIcon from '@mui/icons-material/MoreTime';


import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Checkbox,
    FormControlLabel,

    Stack,
    Typography,
} from "@mui/material";

import { toNow } from "../Common/helpers";

export default function ProspectDealCard({ dl, app, user_undone }) {
    const [state, setState] = useState({ ctx: undefined });
    const handleChangeCheckbox = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    return (
        <CardTemplate
            title={<Typography variant="h5">{dl.t}</Typography>}
            buttons={
                (!dl.oabs || !(dl.oabs && (dl.bid_p === null || (dl.bid_p !== null && !dl.bid_p.a)))) ? <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<MoreTimeIcon />}
                    onclick={() => {
                        app.refPopUp.current.handleChangeState(
                            {
                                opened: true,
                                type: "038",
                                params: {
                                    id: dl.u,
                                    actualDeal: dl,
                                    internal: true
                                }
                            })
                    }}
                >
                    Prendre rendez-vous
                </Button> : null}
            badge={false}

            content={
                < Fragment >
                    <Card sx={{ display: 'flex' }} style="cursor: pointer; margin-bottom: 10px;">
                        <CardMedia
                            component="img"
                            sx={{ display: { xs: 'none', sm: 'block' }, width: 100 }}
                            image={`${THUMBS_URL}/${dl.u}/${dl.main_pic.uid}-main.jpg`}
                            alt=""
                            onClick={() => {
                                window.location.href = dl.oabs
                                    ? "/1fdf58e512f54752959b369588380557/" + dl.u
                                    : "/publicpage/" + dl.u;
                            }}
                        />
                        <CardContent
                            style="width: 100%; ; padding: 5px; background-color: #f7f7f7b3;">
                            <Box display="flex" justifyContent={"space-evenly"} alignItems="center" style="width: 100%;  height: 100%;">
                                <Box
                                    style="cursor: pointer; height: 100%;"
                                    p={1}
                                >
                                    <Stack spacing={0.5} justifyContent={"center"} style="height: 100%;">
                                        <Stack spacing={0.5} justifyContent={"center"} style="height: 100%;" onClick={() => {
                                            window.location.href = dl.oabs
                                                ? "/1fdf58e512f54752959b369588380557/" + dl.u
                                                : "/publicpage/" + dl.u;
                                        }}>
                                            {/* <Typography variant="h5">{dl.t}</Typography> */}
                                            <Typography variant="body1">{dl.mn}</Typography>
                                            {/* <Box display="flex" justifyContent="flex-start" alignItems="center">
                                                <Box > */}
                                            <Typography variant="body1">{dl.s} m2 - {dl.p} €</Typography>
                                            {/* </Box>
                                                <Box style="margin-left: 10px; margin-right: 10px;"> */}
                                            {/* <Typography variant="body1"></Typography> */}
                                            {/* </Box>
                                                <Box> */}
                                            {dl.r && <Typography variant="body1">{dl.r} pièces</Typography>}
                                            {/* </Box>
                                            </Box> */}
                                        </Stack>
                                    </Stack>
                                </Box>
                                <Box style="height: 100%;" p={1}>
                                    {/* <Paper style={{ margin: "5px", padding: "10px", width: "100%", backgroundColor: palette.blueAlert, height: "100%" }}> */}
                                    <Stack spacing={1} justifyContent={"center"} alignItems="center" >
                                        {dl.oabs && (dl.bid_p === null || (dl.bid_p !== null && !dl.bid_p.a)) && (
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Box>
                                                    <Typography variant="h5">Le bien a été promis à un autre</Typography>
                                                </Box>
                                                <Box>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={dl.follow_up}
                                                                onChange={handleChangeCheckbox}
                                                                name="follow_up"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Ne pas être prévenu en cas d'échec"
                                                    />
                                                </Box>
                                            </Box>
                                        )}
                                        {!dl.oabs && dl.bid_p === null && (< Typography variant="h5">Vous n'avez pas encore</Typography>)}
                                        {!dl.oabs && dl.bid_p === null && (< Typography variant="h5">formulé d'offre</Typography>)}


                                        {(!dl.oabs && dl.bid_p === null) && (<Button
                                            variant="contained"
                                            onClick={() => {
                                                user_undone
                                                    ? app.refPopUp.current.handleChangeState(
                                                        {
                                                            opened: true,
                                                            type: "021",
                                                            params: {
                                                                uid: dl.u,
                                                                prev: false,
                                                                seller_price: dl.p,
                                                                seller_price_num: dl.p_num
                                                            }
                                                        })
                                                    : app.refPopUp.current.handleChangeState(
                                                        {
                                                            opened: true,
                                                            type: "001",
                                                            params: {
                                                                title: "Vous êtes à deux clics de pouvoir le faire !",
                                                                body: (
                                                                    <div>
                                                                        <Typography variant="body1" gutterBottom>
                                                                            Vous ne pouvez pas faire de proposition à un
                                                                            vendeur sans avoir d'abord quelques
                                                                            informations vous concernant.
                                                                        </Typography>
                                                                        <Stack flexDirection={"row"} justifyContent={"center"}>
                                                                            <Button variant="contained" onClick={() => { window.location.href = "/user" }}>
                                                                                Aller à mon profil
                                                                            </Button>
                                                                        </Stack>
                                                                    </div>
                                                                )
                                                            }
                                                        })
                                            }}
                                        >
                                            Faire une offre
                                        </Button>)}


                                        {!dl.oabs && dl.bid_p !== null && !dl.bid_p.a && dl.bid_p.cp !== undefined && (
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Box>
                                                    <Typography variant="body1">Votre offre actuelle: {dl.bid_p.p} €</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="h5">Contre-offre acquéreur: {dl.bid_p.cp} €</Typography>
                                                </Box>
                                                <Box>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => app.refPopUp.current.handleChangeState(
                                                            {
                                                                opened: true,
                                                                type: "014",
                                                                params: {
                                                                    bid: dl.bid_p
                                                                }
                                                            })}>Voir la contre-offre</Button>
                                                </Box>
                                            </Box>
                                        )}
                                        {!dl.oabs && dl.bid_p !== null && !dl.bid_p.a && dl.bid_p.cp === undefined && (
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Box>
                                                    <Typography variant="h5">Votre offre actuelle: {dl.bid_p.p} €</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="h5">Expire dans {toNow(dl.bid_p.td1)}</Typography>
                                                </Box>
                                            </Box>
                                        )}
                                        {dl.oabs && dl.bid_p !== null && dl.bid_p.a && (
                                            <Typography variant="h5">
                                                {dl.bid_p.cp === undefined
                                                    ? "Le vendeur a accepté"
                                                    : "Vous avez accepté"}
                                            </Typography>)}
                                        {dl.oabs && dl.bid_p !== null && dl.bid_p.a && (
                                            <Typography variant="h5">
                                                {dl.bid_p.cp === undefined
                                                    ? "votre offre :)"
                                                    : "l'offre du vendeur :)"}
                                            </Typography>)}
                                        {dl.oabs && dl.bid_p !== null && dl.bid_p.a && (
                                            <Typography variant="h5">
                                                {dl.bid_p.cp === undefined ? dl.bid_p.p : dl.bid_p.cp} €
                                            </Typography>
                                        )}
                                    </Stack>
                                    {/* </Paper> */}
                                </Box>
                            </Box>
                        </ CardContent >
                    </Card >
                </Fragment >
            }
        />)

}

